var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTierIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.04785 3.10298C9.41443 2.27817 10.585 2.27818 10.9516 3.10298L12.7707 7.19593C13.2243 8.21658 14.4641 8.61679 15.4289 8.05401L17.1055 7.07597C17.9218 6.59979 18.8993 7.36928 18.6283 8.27439L16.4323 15.644C16.427 15.6619 16.4209 15.6794 16.4142 15.6964C16.3603 15.8625 16.2645 15.998 16.1668 16.1003C16.0216 16.2523 15.8387 16.3689 15.6574 16.4608C15.2927 16.6456 14.8057 16.7939 14.2557 16.9117C13.1455 17.1496 11.6412 17.2917 9.99999 17.2917C8.35875 17.2917 6.85444 17.1496 5.74425 16.9117C5.19426 16.7939 4.70729 16.6456 4.34261 16.4608C4.16124 16.3689 3.97837 16.2523 3.83316 16.1003C3.73744 16 3.64342 15.8679 3.58906 15.7062C3.5809 15.6865 3.57366 15.6661 3.56743 15.6452L1.37136 8.27506C1.10045 7.36996 2.07767 6.59979 2.89396 7.07597L4.5706 8.05401C5.53537 8.61679 6.77514 8.21658 7.22876 7.19593L9.04785 3.10298ZM5.0641 15.4167C5.28957 15.5092 5.60414 15.6033 6.00616 15.6895C7.00721 15.904 8.41957 16.0417 9.99999 16.0417C11.5804 16.0417 12.9928 15.904 13.9938 15.6895C14.3958 15.6033 14.7104 15.5091 14.9359 15.4167C14.7104 15.3243 14.3958 15.2301 13.9938 15.144C12.9928 14.9294 11.5804 14.7917 9.99999 14.7917C8.41957 14.7917 7.00721 14.9294 6.00616 15.144C5.60414 15.2301 5.28957 15.3243 5.0641 15.4167Z",
    fill: "#252525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00617 15.6895C5.60416 15.6034 5.28959 15.5092 5.06412 15.4167C5.28959 15.3243 5.60416 15.2301 6.00617 15.144C7.00723 14.9295 8.41959 14.7917 10 14.7917C11.5804 14.7917 12.9928 14.9295 13.9938 15.144C14.3959 15.2301 14.7104 15.3243 14.9359 15.4167C14.7104 15.5092 14.3959 15.6034 13.9938 15.6895C12.9928 15.904 11.5804 16.0417 10 16.0417C8.41959 16.0417 7.00723 15.904 6.00617 15.6895Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTierIcon);
export default __webpack_public_path__ + "static/media/TierIcon.288a1381212d381228ddfe05d913ab38.svg";
export { ForwardRef as ReactComponent };